import b, { useRef as f, useEffect as T } from "react";
import p from "classnames";
import './TextArea.css';const y = "TextArea-module__text_area___abZSP", A = "TextArea-module__disabled___N09tP", r = {
  text_area: y,
  disabled: A
}, E = ({
  className: s,
  onChange: l,
  value: _,
  placeholder: c = "",
  rows: o = 6,
  disabled: a,
  focus: t,
  name: d,
  id: n,
  ariaDescribedBy: u,
  ariaLabelledBy: i,
  autoComplete: m
}) => {
  const e = f(null);
  return T(() => {
    t && e.current && e.current.focus();
  }, [t]), /* @__PURE__ */ b.createElement(
    "textarea",
    {
      id: n,
      "aria-describedby": u,
      "aria-labelledby": i,
      ref: e,
      name: d,
      autoComplete: m,
      className: p(r.text_area, s, {
        [r.disabled]: a
      }),
      rows: o,
      placeholder: c,
      value: _,
      disabled: a,
      onChange: (x) => l(x.target.value)
    }
  );
};
export {
  E as T
};
